import type { BlockOpenAPIOperationData } from '@gitbook/doc-core';
import type { BlockProps } from '@gitbook/slate-react';

import { BlockOpenAPIFetchWrapper } from './BlockOpenAPIFetchWrapper';
import { OpenAPIOperationBlockContent } from './OpenAPIOperation';

/**
 * Component to render a openapi-operation block.
 */
export function BlockOpenAPIOperation(props: BlockProps) {
    const data = props.node.data.toFrozenObject<BlockOpenAPIOperationData>();
    const { path, method } = data;

    return (
        <BlockOpenAPIFetchWrapper {...props} data={data}>
            {({ filesystem, specUrl }) => {
                return (
                    <OpenAPIOperationBlockContent
                        specUrl={specUrl}
                        filesystem={filesystem}
                        path={path}
                        method={method}
                    />
                );
            }}
        </BlockOpenAPIFetchWrapper>
    );
}
